import React, { useCallback, useEffect, useState } from "react";
import { teamApi } from "../../lib/api";
import { UserPlus } from "lucide-react";
import { AssignTeamModal } from "./AssignTeamModal";

export const initials = (s = "") => (s.trim().split(/[\s@._-]+/).filter(Boolean).slice(0, 2).map((x) => x[0]).join("") || "?").toUpperCase();
const HUES = [86, 200, 330, 40, 260, 160];
export const hueFor = (s = "") => HUES[[...s].reduce((a, c) => a + c.charCodeAt(0), 0) % HUES.length];

export const Avatar = ({ name, email, size = 24, title }) => (
  <span className="tm-avatar" title={title || `${name}${email ? ` · ${email}` : ""}`} style={{ width: size, height: size, fontSize: size * 0.42, "--h": hueFor(email || name) }}>{initials(name || email)}</span>
);

export const useAssignments = (scope, dealKey, dealName) => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => {
    if (!dealKey && !dealName) return Promise.resolve();
    return teamApi.assignments({ dealKey, dealName, scope }).then(setRows).catch(() => setRows([]));
  }, [scope, dealKey, dealName]);
  useEffect(() => { load(); }, [load]);
  return [rows, load];
};

export const TeamChips = ({ scope, dealKey, dealName, label, onChanged, compact }) => {
  const [rows, reload] = useAssignments(scope, dealKey, dealName);
  const [open, setOpen] = useState(false);
  const refresh = () => { reload(); onChanged?.(); };
  return (
    <div className={`tm-chips ${compact ? "compact" : ""}`} data-testid={`team-chips-${scope}`}>
      {label && <span className="tm-label">{label}</span>}
      <div className="tm-stack">
        {rows.map((a) => <Avatar key={a.id} name={a.name} email={a.email} title={`${a.name}${a.role ? ` · ${a.role}` : ""}`} />)}
        {rows.length === 0 && <span className="tm-none">No one assigned</span>}
      </div>
      <button className="btn btn-sm tm-assign" onClick={() => setOpen(true)} data-testid={`team-assign-${scope}`}><UserPlus size={12} />Assign team</button>
      <AssignTeamModal open={open} onClose={() => setOpen(false)} scope={scope} dealKey={dealKey} dealName={dealName} rows={rows} onChanged={refresh} />
    </div>
  );
};
